export default "__VITE_ASSET__CqHM_dPA__"